'use client'

import Image from 'next/image'

import useMediaQuery from '@equifax-ui/hooks/useMediaQuery'

import { Container, Proposal } from '@/components'

import styles from './Hero.module.scss'

export const Hero = ({ variant, title, subtitle, image }) => {
  const isDesktop = useMediaQuery('screen and (min-width: 1024px)')

  return (
    <section
      id="inicio"
      className={`${styles.hero} ${styles[`hero--${variant}`]}`}
    >
      {isDesktop && (
        <Image
          priority
          placeholder="blur"
          width={1440}
          height={584}
          src={image.src}
          alt={image.alt}
          className={styles.hero__img}
        />
      )}

      <Container classname={styles.container}>
        <div className={styles.hero__wrapper}>
          <div className={styles.hero__content}>
            <h1 className={styles.hero__title}>{title}</h1>
            <p className={styles.hero__subtitle}>{subtitle}</p>
          </div>

          <Proposal />
        </div>
      </Container>
    </section>
  )
}
